import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CustomersCreateDataPage } from '../../../customers/customers-create/customers-create-data/customers-create-data';
import { OrdersCoServices } from '../../services';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-table-info',
  templateUrl: 'orders-table-info.html',
})
export class OrdersTableInfoPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    private toastCtrl: ToastController,
    public translate: TranslateService,) {
  }

  ionViewDidLoad() {

  }

  back() {
    this.navCtrl.pop();
  }

  showInfoCustomer() {
    if (this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.UID) {
      this.navCtrl.push(CustomersCreateDataPage, {
        update_state: true,
        customer_uid: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.UID,
        name: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.name,
        business_name: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.business_name,
        business_number: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.business_number,
        email: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.email,
        phone: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.phone,
        address: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.address,
        note: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.note,
        alegra_contact_id: this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].customer.alegra_contact_id,
      })
    }else{
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-no-hay-cliente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table-info/orders-table-info.ts